"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReflectiveCurseAbilityHandler = exports.ReflectiveCurseActorAbilityFactory = exports.ReflectiveCurseAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
class ReflectiveCurseAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ReflectiveCurse;
        this.__typeName = "ReflectiveCurse";
    }
}
exports.ReflectiveCurseAbilityArgs = ReflectiveCurseAbilityArgs;
let ReflectiveCurseActorAbilityFactory = class ReflectiveCurseActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ReflectiveCurse", "Self", 0);
    }
};
ReflectiveCurseActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ReflectiveCurse")
], ReflectiveCurseActorAbilityFactory);
exports.ReflectiveCurseActorAbilityFactory = ReflectiveCurseActorAbilityFactory;
let ReflectiveCurseAbilityHandler = class ReflectiveCurseAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
            effect: new core_1.Passive_ReflectiveCurseEffectArgs()
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
ReflectiveCurseAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ReflectiveCurse)
], ReflectiveCurseAbilityHandler);
exports.ReflectiveCurseAbilityHandler = ReflectiveCurseAbilityHandler;
